export enum MjmlSmName {
  facebook = 'facebook-noshare',
  twitter = 'twitter-noshare',
  linkedin = 'linkedin-noshare',
  instagram = 'instagram',
}
